module.exports = __webpack_public_path__ + "img/LT.68cb729c.svg";